import React, { useState } from 'react';
import { Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { WizardSteps } from './index';
import { createStyles, withStyles, Button, Grid } from '@material-ui/core';
import SubmitButton from '../buttons/SubmitButton';
import FormErrorLabel from './FormErrorLabel';

const styles = (theme) =>
  createStyles({
    footer: {
      marginTop: theme.spacing(4),
    },

    secondaryButton: {
      backgroundColor: theme.palette.secondary.light,

      '&:hover': {
        backgroundColor: theme.palette.primary.light,
      },
    },
  });

const Wizard = ({ classes, initialValues = {}, common = <></>, steps, onSubmit }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const isLastStep = currentStep === steps.length - 1;

  const goToPreviousStep = () => setCurrentStep((index) => index - 1);
  const goToNextStep = () => setCurrentStep((index) => index + 1);

  const handleSubmitForm = (values) => {
    if (!isLastStep) {
      goToNextStep();
      return;
    }

    return onSubmit(values).catch((err) => ({ [FORM_ERROR]: err.message }));
  };

  const Page = steps[currentStep].component;

  return (
    <div>
      <WizardSteps steps={steps} currentStep={currentStep} onSelect={setCurrentStep} />

      <Form
        initialValues={initialValues}
        onSubmit={handleSubmitForm}
        render={({ handleSubmit, submitting, values, ...renderProps }) => (
          <form onSubmit={handleSubmit}>
            {common}

            <Page values={values} form={renderProps.form} />

            <FormErrorLabel {...renderProps} />

            <Grid container spacing={2} className={classes.footer}>
              <Grid item xs={6}>
                <Button
                  className={classes.secondaryButton}
                  fullWidth
                  variant="contained"
                  color="secondary"
                  size="large"
                  disabled={currentStep === 0}
                  onClick={goToPreviousStep}>
                  Previous
                </Button>
              </Grid>
              <Grid item xs={6}>
                <SubmitButton
                  fullWidth
                  color="primary"
                  size="large"
                  submitting={submitting}
                  label={isLastStep ? 'Submit' : 'Next'}
                />
              </Grid>
            </Grid>
          </form>
        )}
      />
    </div>
  );
};

export default withStyles(styles)(Wizard);
